export enum TaskManagerTag {
  ServiceType = 'ServiceType',
  Status = 'status',
  Task = 'task',
  UserName = 'UserName'
}

export const TaskManagerTagsMap = new Map<TaskManagerTag, { tag: string; prop: string }>([
  [TaskManagerTag.UserName, { tag: 'User name', prop: 'UserName' }],
  [TaskManagerTag.ServiceType, { tag: 'Service type', prop: 'ServiceType' }],
  [TaskManagerTag.Task, { tag: 'Task', prop: 'OperationType' }],
  [TaskManagerTag.Status, { tag: 'Status', prop: 'State' }]
]);
